import { Outlet } from 'react-router-dom';

import { Logout } from './Logout';
import { routes as oktaRoutes } from './Okta';

const authRoutes = {
  path: '/auth',
  element: <Outlet />,
  children: [
    oktaRoutes,
    {
      path: 'logout',
      element: <Logout />,
    },
  ],
};

export { authRoutes };
